import { createBrowserRouter } from "react-router-dom";
import App from "../components/App";
import Detalle from "../pages/Alquiler/Detalle";
import CargaAlquiler from "../pages/Admin/Alquiler/Carga";
import PasosAlquiler from "../pages/Admin/Alquiler/Nuevo";
import CargaExcursion from "../pages/Admin/Excursion/Carga";
import PasosExcursion from "../pages/Admin/Excursion/Nuevo/Index";
import Reserva from "../pages/Reserva/Reserva";
import Informacion from "../pages/Perfil/Informacion";
import Cuenta from "../pages/Perfil/Cuenta";
import Pagos from "../pages/Perfil/Pagos";
import Cobros from "../pages/Perfil/Cobros";
import Notificaciones from "../pages/Perfil/Notificaciones";
import Excursiones from "../pages/Excursiones";
import Seguridad from "../pages/Perfil/seguridad";
import Preferencias from "../pages/Perfil/preferencias";
import DetalleExcursion from "../pages/Excursion/Detalle";
import EditarAlquiler from "../pages/Admin/Alquiler/Editar";
import MisAlquileres from "../pages/Admin/Alquileres/Index";
import Verificar from "../pages/Verificar";
import Reservas from "../pages/Admin/Reservas/Reservas";
import Ingresos from "../pages/Admin/Ingresos/Ingresos";
import Info from "../pages/Admin/Info/Info";
import { AppProvider } from "../contexts/AppProvider";
import MisExcursiones from "../pages/Admin/Excursiones/Index";
import EditarExcursion from "../pages/Admin/Excursion/Editar/Index";
import Favoritos from "../pages/Favoritos";
import Usuarios from "../pages/Admin/Usuarios/Usuarios";
import Ajustes from "../pages/Admin/Ajustes/Ajustes";
import SoporteTecnico from "../pages/SoporteTecnico";
import Faqs from "../pages/Faqs";
import PoliticasCancelacion from "../pages/PoliticasCancelacion";
import PoliticasDePrivacidadYTerminosDeUso from "../pages/PoliticasDePrivacidadYTerminosDeUso";
import RecursosAnfitrion from "../pages/RecursosAnfitrion";
import GuiaParaOptimizarAnuncio from "../pages/GuiaParaOptimizarAnuncio";
import ProblemasAlojamiento from "../pages/ProblemasAlojamiento";
import Modo from "../pages/Modo";
import Home from "../pages/Home";
import  Register  from "../pages/Register";
import RecuperarContraseña from "../pages/recuperar-contraseña";
import Destacados from "../pages/Alojamientos";

import Comisiones from "../pages/Admin/Comisiones/Comisiones";
import { AdminProvider } from "../contexts/AdminProvider";
import Admin from "../components/Admin";
import MisReservas from "../pages/Mis-reservas";
import Chat from "../pages/chat";
import ErrorPage from "../pages/Error";


const router = createBrowserRouter([
  {
    element: (
      <AppProvider>
        <App />
      </AppProvider>
    ),
    children: [
      { path: "/modo/:modo", 
        element: <Modo />
      },
      { path: "/verificar", 
        element: <Verificar /> 
      },
      { path: "/recuperar-contraseña", 
        element: <RecuperarContraseña />
      },
      { path: "/", 
        element: <Home />
      },
      { path: "/login", 
        element: <Register />
      },
      { path: "/checkout/:preference_id", 
        element: <Home />
      },

      {
        /* PUBLICO */
      },
      { path: "/excursiones", element: <Excursiones /> },
      { path: "/excursion/:slug", element: <DetalleExcursion /> },
      { path: "/alojamientos", element: <Destacados /> },
      { path: "/alojamiento/:slug", element: <Detalle /> },
      { path: "/reservar", element: <Reserva /> },

      {
        /* USUARIO */
      },

      { path: "/favoritos", element: <Favoritos /> },
      { path: "/mis-reservas", element: <MisReservas /> },
      { path: "/chat", element: <Chat /> },
      { path: "/chat/:conversationId", element: <Chat /> },

      {
        /* INFORMACION */
      },

      { path: "/soporte-tecnico", element: <SoporteTecnico /> },
      { path: "/preguntas-frecuentes", element: <Faqs /> },
      { path: "/politicas-de-cancelacion", element: <PoliticasCancelacion /> },
      { path: "/problemas-alojamiento", element: <ProblemasAlojamiento /> },
      {
        path: "/privacidad-y-terminos-de-uso",
        element: <PoliticasDePrivacidadYTerminosDeUso />,
      },
      { path: "/recursos-anfitrion", element: <RecursosAnfitrion /> },
      {
        path: "/guia-optimizar-anuncio",
        element: <GuiaParaOptimizarAnuncio />,
      },
      { path: "/404", element: <ErrorPage /> },
      { path: "*", element: <ErrorPage /> },
    ],
  },
  {
    element: (
      <AdminProvider>
        <Admin />
      </AdminProvider>
    ),
    errorElement: <ErrorPage />,
    children: [
      {
        /* MENU */
      },

      { path: "/dashboard", element: <Ingresos /> },
      { path: "/reservas", element: <Reservas /> },
      { path: "/banners", element: <Ajustes /> },
      { path: "/comisiones", element: <Comisiones /> },
      { path: "/usuarios", element: <Usuarios /> },
      { path: "/info", element: <Info /> },
      {
        /* USUARIO */
      },
      { path: "/perfil", element: "" },
      { path: "/informacion", element: <Informacion /> },
      { path: "/cuenta", element: <Cuenta /> },
      { path: "/pagos", element: <Pagos /> },
      { path: "/cobros", element: <Cobros /> },
      { path: "/notificaciones", element: <Notificaciones /> },
      { path: "/seguridad", element: <Seguridad /> },
      { path: "/preferencias", element: <Preferencias /> },

      {
        /* CARGA */
      },

      {
        path: "/alquileres",
        element: <MisAlquileres />,
      },
      { path: "/publicaciones", element: <MisExcursiones /> },

      { path: "/alquiler/carga", element: <CargaAlquiler /> },
      { path: "/alquiler/carga/pasos", element: <PasosAlquiler /> },
      { path: "/alquiler/editar/:slug", element: <EditarAlquiler /> },

      { path: "/excursion/carga", element: <CargaExcursion /> },
      { path: "/excursion/carga/pasos", element: <PasosExcursion /> },
      { path: "/excursion/editar/:slug", element: <EditarExcursion /> },
    ],
  },
]);

export default router;
